<div class="invite-dialog">
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <h2>Invite Teacher</h2>
    <p class="subtitle">
        Send an invitation to a new teacher. Email must be from the institutional domain.
    </p>
      <!-- Honorific -->
  <div class="form-group full-width">
    <label class="field-label">Honorific</label>
    <mat-form-field appearance="outline" class="full-width compact-field">
      <mat-select [(ngModel)]="honorific">
        <mat-option *ngFor="let h of honorifics" [value]="h">{{ h }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
    <div class="form-group full-width">
        <label class="field-label">Full Name</label>
        <mat-form-field appearance="outline" class="full-width compact-field">
            <input matInput [(ngModel)]="fullName" placeholder="Dr. John Doe" />
        </mat-form-field>
    </div>
    <div class="form-group full-width">
        <label class="field-label">Email Address</label>
        <mat-form-field appearance="outline" class="full-width compact-field">
            <input matInput [(ngModel)]="email" placeholder="john.doe@sit.ac.in" />
        </mat-form-field>
    </div>
   <!-- Department -->
<div class="form-group full-width">
  <label class="field-label">Department</label>
  <mat-form-field appearance="outline" class="full-width compact-field">
    <mat-select [(ngModel)]="departmentId" (selectionChange)="onDepartmentChange($event.value)" (openedChange)="onOpenDepartment($event)">
      <mat-select-trigger>
        {{ getDepartmentName(departmentId) }}
      </mat-select-trigger>

      <mat-option *ngFor="let d of departments" [value]="d.id">
        {{ d.name }}
      </mat-option>
      <mat-option value="Other">Other</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="custom-dept-input" *ngIf="departmentId === 'Other'">
    <mat-form-field appearance="outline" class="full-width compact-field">
      <mat-label>Enter Department Name</mat-label>
      <input matInput placeholder="Type department name..." [(ngModel)]="customDepartmentName" />
    </mat-form-field>
  </div>
</div>

<!-- Role -->
<div class="form-group full-width">
  <label class="field-label">Role</label>
  <mat-form-field appearance="outline" class="full-width compact-field">
    <mat-select [(ngModel)]="roleId" (openedChange)="onOpenRole($event)">
      <mat-select-trigger>
        {{ getRoleName(roleId) }}
      </mat-select-trigger>

      <mat-option *ngFor="let r of roles" [value]="r.id">
        {{ r.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


    <div class="actions">
        <button mat-stroked-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" class="dark-blue" (click)="sendInvite()">
			<ng-container *ngIf="isLoading; else noLoading">
			<span class="spinner-border spinner-border-sm"></span> Sending...</ng-container>
		    <ng-template #noLoading>Send Invitation </ng-template>
        </button>
    </div>
</div>